export const INITIAL_PAGE_PARAM = 'initial_page';

export const UTM_PARAM_NAMES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'tduid', 'ranMID', 'promocode', 'from_page'];
